












































































































import Vue from "vue"
import { Employee } from "@/model/entity/employee/employee"
import { RoleEnum } from "@/model/enum/role-enum"

export default Vue.extend({
  data() {
    return {
      editedEmployee: new Employee(),
      passwordVisible: false,
      usernameExists: false,
      rules: {
        username: [
          { required: true, message: this.$t("user_administration.employee_username_required"), trigger: "change" },
          {
            validator: (rule: any, value: any, callback: any) => {
              const vm = this as any
              vm.$http("/employee/validate_username/" + value)
                .then((response: any) => {
                  vm.usernameExists = !!response.data
                  if (response.data) {
                    callback(new Error(vm.$t("user_administration.username_validation")))
                  } else {
                    callback()
                  }
                })
                .catch((error: any) => {
                  callback(error.message)
                })
            },
            trigger: "change"
          },
          {
            max: 20,
            message: `${this.$t("user_administration.max")} 20 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ],
        password: [
          {
            validator: (rule: any, value: any, callback: any) => {
              const vm = this as any
              if (vm.isAdd && (!value || value === "")) {
                callback(new Error(vm.$t("user_administration.employee_password_required")))
              } else {
                callback()
              }
            },
            trigger: "change"
          },
          {
            validator: (rule: any, value: any, callback: any) => {
              const vm = this as any
              if (!!value && value !== "" && value.length < 8) {
                callback(new Error(vm.$t("user_administration.employee_password_length")))
              } else {
                callback()
              }
            },
            trigger: "change"
          },
          {
            max: 512,
            message: `${this.$t("user_administration.max")} 512 ${this.$t("user_administration.chars")}`,
            trigger: "change"
          }
        ]
      }
    }
  },
  props: {
    employee: {
      type: Object as () => Employee,
      default: () => new Employee()
    },
    isAdd: {
      type: Boolean,
      default: false
    },
    employeeNumber: {
      type: Number,
      required: true
    }
  },
  methods: {
    addEmployee() {
      this.$emit("add-employee", this.editedEmployee)
      this.resetEditedEmployee()
    },
    resetEditedEmployee() {
      this.editedEmployee = JSON.parse(JSON.stringify(new Employee()))
    },
    save() {
      this.$emit("save", { employee: this.editedEmployee })
      if (this.isAdd) {
        this.resetEditedEmployee()
      }
    },
    submit() {
      const vm = this
      const call = () => {
        vm.startLoad()
        vm.$http
          .post("/login/send_login", {
            identifier: vm.editedEmployee.username
          }, {
            headers: {
              "client_lang": this.$root.$i18n.locale
            }
          })
          .then((res) => {
            vm.endLoad()
            if (exists(res.data.status)) {
              vm.$error(res.data.message)
            } else {
              this.$message({
                message: vm.$t("user_administration.login_data_sent").toString(),
                type: "success",
                duration: 7000
              })
            }
          })
          .catch(e => {
            vm.$error(e.message)
            vm.endLoad()
          })
      }

      this.$emit("save", { employee: this.editedEmployee, call: call })

    }
  },
  computed: {
    formValid(): boolean {
      const employee = this.editedEmployee!
      if (this.isAdd) {
        return notEmpty(employee.password)
          && notEmpty(employee.username) && !this.usernameExists && employee.password.length >= 8
      }
      return !notEmpty(employee.password)
        || (!this.usernameExists && notEmpty(employee.password) && employee.password.length >= 8)
    },
    availableRoles(): RoleEnum[] {
      let availableRoles = [RoleEnum.DPD, RoleEnum.CUSTOMER, RoleEnum.CUSTOMER_COMPANY]

      if (this.$store.state.authenticatedEmployee.role === RoleEnum.DPD) {
        availableRoles = [RoleEnum.CUSTOMER]
      }

      if (this.$store.state.authenticatedEmployee.role === RoleEnum.ADMIN) {
        availableRoles.push(RoleEnum.GDPR)
      }

      return availableRoles
    },
    validEmail(): boolean {
      if (exists(this.editedEmployee) && notEmpty(this.editedEmployee.email)) {
        // tslint:disable-next-line
        return new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/).test(this.editedEmployee.email!!)
      }
      return true
    }
  },
  created() {
    this.editedEmployee = JSON.parse(JSON.stringify(this.employee))
  }
})
